import EstoqueService from "@/services/EstoqueService";

export const estoque = {
  namespaced: true,
  state: {
    estoque: {},
  },
  actions: {
    getEstoque({ commit }, payload) {
      return EstoqueService.GetEstoque(payload).then(
        (estoque) => {
          return Promise.resolve(estoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoque({ commit }, payload) {
      return EstoqueService.PostEstoque(payload).then(
        (estoque) => {
          return Promise.resolve(estoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoque({ commit }, payload) {
      return EstoqueService.PutEstoque(payload).then(
        (estoque) => {
          return Promise.resolve(estoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoque({ commit }, payload) {
      return EstoqueService.DeleteEstoque(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueOData({ commit }, payload) {
      return EstoqueService.GetEstoqueOData(payload).then(
        (estoque) => {
          return Promise.resolve(estoque);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoque;
